import { FC, ReactNode, SVGAttributes } from 'react';
import { twMerge } from 'tailwind-merge';

interface PropTypes extends SVGAttributes<SVGElement> {
  className?: string;
  children: ReactNode;
}

const Svg: FC<PropTypes> = ({
  children,
  className,
  viewBox = '0 0 24 24',
  fill = 'none',
  ...rest
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      className={twMerge('h-5 w-5 stroke-2 stroke-black', className)}
      fill={fill}
      viewBox={viewBox}
      {...rest}>
      {children}
    </svg>
  );
};

export default Svg;
